import React from 'react';

export const DeveloperToolsIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="18" viewBox="0 0 24 18" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.06805 3.08234L7.93834 3.95263L2.89096 9L7.93834 14.0474L7.06805 14.9177L1.15039 9L7.06805 3.08234Z"
      fill="currentColor"
    />
    <path d="M14.4614 1L10.858 17H9.53833L13.1417 1H14.4614Z" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.1088 9L16.0614 3.95262L16.9317 3.08234L22.8494 9L16.9317 14.9177L16.0614 14.0474L21.1088 9Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.06805 3.08234L7.93834 3.95263L2.89096 9L7.93834 14.0474L7.06805 14.9177L1.15039 9L7.06805 3.08234Z"
      stroke="currentColor"
      strokeWidth="0.5"
    />
    <path
      d="M14.4614 1L10.858 17H9.53833L13.1417 1H14.4614Z"
      stroke="currentColor"
      strokeWidth="0.5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.1088 9L16.0614 3.95262L16.9317 3.08234L22.8494 9L16.9317 14.9177L16.0614 14.0474L21.1088 9Z"
      stroke="currentColor"
      strokeWidth="0.5"
    />
  </svg>
);
